export class TimeOfDay {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "hour",
            "baseName": "hour",
            "type": "number",
            "format": ""
        },
        {
            "name": "minute",
            "baseName": "minute",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TimeOfDay.attributeTypeMap;
    }
    constructor() {
    }
}
